import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Building = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M8 3.96a1 1 0 0 0-1 1v17h10v-17a1 1 0 0 0-1-1zm11 5v-4a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v7H4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3zm0 2v11h1a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zm-14 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1zm4-7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1'
        clipRule='evenodd'
      />
    </svg>
  );
};
